<template>
    <div class="software">
        <div class="top-banner">
            <div class="main_content">
                <div class="top-banner-title">软件服务与支持</div>
                <div class="top-banner-text">给你的服务是看得见的温度</div>
            </div>
        </div>
        <div class="software_container software_container_gray">
            <div class="main_content">
                <div class="software_container-title">面向打印机用户</div>
                <div class="content1">
                    <div class="content1-main">
                        <img class="content1-main-title" src="./images/title1.png" alt="title">
                        <div class="content1-main-item">
                            <span class="content1-main-item-span">驱动安装：</span>
                            支持快麦及其他主流热敏打印机安装驱动
                        </div>
                        <div class="content1-main-item">
                            <span class="content1-main-item-span">驱动设置：</span>
                            打印机浓度、速度、纸张尺寸等常用设置项
                        </div>
                        <div class="content1-main-item">
                            <span class="content1-main-item-span">共享打印：</span>
                            usb打印可共享多人使用，不限打印距离
                        </div>
                        <div class="content1-main-item">
                            <span class="content1-main-item-span">云驱动：</span>
                            菜鸟、快麦云打印机安装云驱动，所有软件打印
                        </div>
                        <div class="content1-main-download">立即下载</div>
                        <div class="content1-main-download-list">
                            <div class="content1-main-download-btn"
                                 @click="openNew('https://gj.fanqie365.cn/?sc=guanwang')">
                                <img class="content1-main-download-btn-icon" src="./images/windows.png" alt="icon">
                                Windows
                            </div>
                            <div class="content1-main-download-btn"
                                 @click="openNew('https://gj.fanqie365.cn/?sc=guanwang')">
                                <img class="content1-main-download-btn-icon" src="./images/mac.png" alt="icon">
                                Macos
                            </div>
                            <div class="content1-main-download-btn"
                                 @click="openNew('https://gj.fanqie365.cn/?sc=guanwang')">
                                <img class="content1-main-download-btn-icon" src="./images/huawei.png" alt="icon">
                                HarmonyOS
                            </div>
                        </div>
                    </div>
                    <img class="content1-img" src="./images/content1.png" alt="img">
                </div>
                <div class="content1 content1-2">
                    <img class="content1-img2" src="./images/content2.png" alt="img">
                    <div class="content1-main">
                        <img class="content1-main-title" src="./images/title2.png" alt="title">
                        <div class="content1-main-item">
                            <span class="content1-main-item-span">免费标签编辑：</span>
                            免费编辑条码，可插入文本、条码、二维码、表格、图标等组<br/>件，智能排版，支持主流品牌机器打印
                        </div>
                        <div class="content1-main-item">
                            <span class="content1-main-item-span">标签批量打印：</span>
                            可上传excel、自动序列号，可批量打印标签
                        </div>
                        <div class="content1-main-item">
                            <span class="content1-main-item-span">PDF裁剪与分割：</span>
                            PDF裁剪空白、多内容智能分割并打印
                        </div>
                        <div class="content1-main-download">立即下载</div>
                        <div class="content1-main-download-list">
                            <div class="content1-main-download-btn"
                                 @click="openNew('https://gj.fanqie365.cn/?sc=guanwang')">
                                <img class="content1-main-download-btn-icon" src="./images/windows.png" alt="icon">
                                Windows
                            </div>
                            <div class="content1-main-download-btn"
                                 @click="openNew('https://gj.fanqie365.cn/?sc=guanwang')">
                                <img class="content1-main-download-btn-icon" src="./images/mac.png" alt="icon">
                                Macos
                            </div>
                            <div class="content1-main-download-btn"
                                 @click="openNew('https://gj.fanqie365.cn/?sc=guanwang')">
                                <img class="content1-main-download-btn-icon" src="./images/mac.png" alt="icon">
                                iOS
                            </div>
                            <div class="content1-main-download-btn"
                                 @click="openNew('https://gj.fanqie365.cn/?sc=guanwang')">
                                <img class="content1-main-download-btn-icon" src="./images/android.png" alt="icon">
                                Android
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="software_container software_container_white">
            <div class="main_content">
                <div class="software_container-title">面向软件开发者</div>
                <div class="content2">
                    <div class="content2-col" @click="openNew('https://solution.kuaimai.com/')">
                        <img class="content2-col-img" src="./images/content3.png" alt="img">
                        <img class="content2-col-title" src="./images/title3.png" alt="title">
                        <div class="content2-col-text">
                            为SaaS企业提供标签/小票模板编辑与跨平台打印解决方案，提供ApI接口低成本对接即可实现SaaS用户在线模板编辑打印，为企业降本增效。
                        </div>
                    </div>
                    <div class="content2-col" @click="openNew('https://cloudprint.kuaimai.com/')">
                        <img class="content2-col-img" src="./images/content4.png" alt="img">
                        <img class="content2-col-title" src="./images/title4.png" alt="title">
                        <div class="content2-col-text">
                            快麦云打印是基于快麦云打印机和快麦云软硬件为一体的解决方案；快麦云打印机联网后设备上云，SaaS软件方通过快麦API接口对接快麦云，并将打印信息通过快麦云端下发给到打印机，打印数据云端保存、云端下发，保证打印不漏单。
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "software",
    data() {
        return {};
    },
    mounted() {
    },
    methods: {},
};
</script>

<style lang="scss" scoped>
.software {
    .top-banner {
        box-sizing: border-box;
        padding-top: 226rem;
        height: 500rem;
        background: url("./images/top-bg.png") center / 1920rem 500rem no-repeat;

        .top-banner-title {
            margin: 0 0 17rem 0;
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 64rem;
            color: #333333;
            line-height: 90rem;
        }

        .top-banner-text {
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 24rem;
            color: #333333;
            line-height: 34rem;
        }
    }

    .software_container {
        padding: 48rem 0 78rem;

        &.software_container_gray {
            background: #F2F3F5;
        }

        &.software_container_white {
            background: #FFFFFF;
        }

        .software_container-title {
            margin-bottom: 51rem;
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 40rem;
            color: #333333;
            line-height: 56rem;
            text-align: center;
        }

        .content1 {
            margin-bottom: 39rem;
            height: 480rem;
            box-shadow: -4rem 0 0 0 #FD6520;
            border-radius: 20rem;
            background: #FFFFFF;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            gap: 16rem;

            &.content1-2 {
                box-shadow: 4rem 0 0 0 #FD6520;
            }

            .content1-img {
                width: 434rem;
            }

            .content1-img2 {
                width: 364rem;
            }

            .content1-main {

                .content1-main-title {
                    height: 46rem;
                    margin-bottom: 32rem;
                }

                .content1-main-item {
                    margin-bottom: 10rem;
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 500;
                    font-size: 14rem;
                    color: #333333;
                    line-height: 20rem;

                    .content1-main-item-span {
                        color: #FD6520;
                    }
                }

                .content1-main-download {
                    margin: 14rem 0 15rem;
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 500;
                    font-size: 16rem;
                    color: #666666;
                    line-height: 22rem;
                }

                .content1-main-download-list {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    gap: 12rem;

                    .content1-main-download-btn {
                        padding: 10rem 17rem;
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        justify-content: center;
                        gap: 11rem;
                        background: #FFFFFF;
                        border-radius: 100rem;
                        border: 1px solid #FD6520;
                        font-family: PingFangSC, PingFang SC;
                        font-weight: 500;
                        font-size: 16rem;
                        color: #FD6520;
                        line-height: 22rem;
                        cursor: pointer;

                        &:hover {
                            transform: scale(1.1);
                        }

                        .content1-main-download-btn-icon {
                            width: 28rem;
                        }
                    }
                }
            }
        }

        .content2 {
            margin-top: 59rem;
            display: flex;
            flex-direction: row;
            gap: 40rem;

            .content2-col {
                display: flex;
                flex-direction: column;
                align-items: center;
                width: 580rem;
                height: 489rem;
                border-radius: 20rem;
                background: #FFFFFF;
                box-shadow: 0 2rem 20rem 0 rgba(0, 0, 0, 0.1);
                overflow: hidden;
                cursor: pointer;

                &:hover {
                    transform: scale(1.05);
                }

                .content2-col-img {
                    width: 100%;
                }

                .content2-col-title {
                    margin: 26rem 0 10rem;
                    height: 70rem;
                }

                .content2-col-text {
                    padding: 0 34rem;
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 400;
                    font-size: 16rem;
                    color: #333333;
                    line-height: 30rem;
                    text-shadow: 0 2rem 20rem rgba(0, 0, 0, 0.1);
                    text-align: center;
                }
            }
        }
    }
}
</style>
